import Button from "@mui/material/Button";
import {ArrowBackIos} from "@mui/icons-material";
import Container from "@mui/material/Container";
import {RoutePaths} from "../../util/constants";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import Navbar from "../../component/navbar/Navbar";
import Paper from "@mui/material/Paper";
import React, {ReactElement} from "react";
import ScrollTopContainer from "../../component/shared/scroll-top-container/ScrollTopContainer";
import {alpha, CssBaseline, ThemeProvider} from "@mui/material";
import {whiteInputsTheme} from "../../util/theme/whiteInputsTheme";
import Footer from "../footer/Footer";
import {useTheme} from "@mui/material/styles";

interface Props {
    window?: () => Window;
    children: ReactElement;
}

const AuthLayout = (props: Props) => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const location = useLocation()
    const theme = useTheme()

    const handleBackButtonClick = () => {
        navigate(location.pathname.includes('password') || location.pathname.includes('confirmation') ? RoutePaths.AUTH : RoutePaths.HOME)
    }

    return (
        <ScrollTopContainer>
            <>
                <Navbar/>
                <ThemeProvider theme={whiteInputsTheme}>
                    <CssBaseline/>
                    <Container component="main" maxWidth="sm" sx={{
                        mt: '6em',
                        display: 'flex',
                        flexDirection: 'column',
                        flexGrow: 1,
                        gap: '1em',
                        alignItems: 'start'
                    }}>
                        <Button color="primary"
                                variant="outlined"
                                onClick={handleBackButtonClick}
                                startIcon={<ArrowBackIos/>}>
                            {location.pathname.includes('password') || location.pathname.includes('confirmation') ? t('login') : t('home')}
                        </Button>
                        <Paper elevation={5} sx={{
                            padding: '1em',
                            backgroundColor: `${alpha(theme.palette.primary.main, .1)}`,
                            backdropFilter: "blur(5px)",
                            width: '100%'
                        }}>
                            {props.children}
                        </Paper>
                    </Container>
                </ThemeProvider>
                <Footer/>
            </>
        </ScrollTopContainer>
    )
}
export default AuthLayout
